// extracted by mini-css-extract-plugin
module.exports = {"carousel":"product-carousel_carousel___laDT","carousel__card":"product-carousel_carousel__card__qGKib"};